import React, {Component} from 'react';
import connect from "react-redux/es/connect/connect";

import {Dialog, FlatButton } from "material-ui";
import ContentCreate from "material-ui/svg-icons/content/create";

import { List, FilterForm, Datagrid } from 'components/list';
import { TextInput } from 'components/input';
import { TextField } from 'components/field';
import { EditButton } from 'components/button';

import {
  COUNTRY_TH,
  COUNTRY_VN,
} from 'util/constants';

import {
  ownerChangeMobileFrontendPath,
  ownerAdminChangeMobileFrontendPath,
  ownerMergeShopFrontendPath,
} from './urls';
import {shopOwnerExpireSession} from "actions";


export const OwnerListFilter = (props) => (
  <FilterForm name="owner_search" {...props}>
    <TextInput isRequired={true} label="Mobile" source="mobile_number"/>
  </FilterForm>
);

const ExpireSessionButton = (props) => (
  <FlatButton
    {...props}
    primary
    icon={<ContentCreate />}
    onClick={() => props.openConfirmDialogExpirySession(props.record.owner_mobile_number)}/>
);

class OwnerList extends Component {
  state = {
    isOpenConfirmExpirySession: false,
    ownerMobileNumber: '',
  }

  openConfirmDialogExpirySession = (ownerMobileNumber) => {
    this.setState({
      isOpenConfirmExpirySession: true,
      ownerMobileNumber: ownerMobileNumber,
    })
  }

  expireSession = () => {
    this.props.dispatch(shopOwnerExpireSession({
      mobile_number: this.state.ownerMobileNumber,
    }));
    this.setState({
      isOpenConfirmExpirySession: false
    })
  }

  handleCloseConfirmDialog = () => {
    this.setState({
      isOpenConfirmExpirySession: false
    })
  }

  render() {
    const actions = [
      <FlatButton
        label="No"
        onTouchTap={this.handleCloseConfirmDialog}
      />,
      <FlatButton
        label="Yes"
        primary={true}
        keyboardFocused={true}
        onTouchTap={this.expireSession}
      />,
    ];

    return (
      <div>
        <List hasCreate={true} {...this.props} filters={<OwnerListFilter />}>
          <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
            <TextField source="shop_id" label="Shop ID"/>
            <TextField source="shop_name" label="Shop Name"/>
            <TextField source="owner_mobile" label="Owner Mobile"/>
            <TextField source="owner_name" label="Owner Name"/>
            <EditButton linkTo={ownerChangeMobileFrontendPath} label="Mobile"/>
            <EditButton linkTo={ownerAdminChangeMobileFrontendPath} label="Admin Mobile"/>
            {
              (process.env.REACT_APP_COUNTRY === COUNTRY_TH ||
                process.env.REACT_APP_COUNTRY === COUNTRY_VN) &&
              <EditButton linkTo={ownerMergeShopFrontendPath} label="Merge Shop"/>
            }
            <ExpireSessionButton
              label="Expiry Session"
              openConfirmDialogExpirySession={this.openConfirmDialogExpirySession} />
          </Datagrid>
        </List>
        <Dialog
          title="Confirm"
          actions={actions}
          modal={false}
          open={this.state.isOpenConfirmExpirySession}
        >
          Are you sure you want to do this action?
        </Dialog>
      </div>
    );
  }
}

export default connect()(OwnerList);



// WEBPACK FOOTER //
// ./src/routes/shop/OwnerList.js